<template>
  <div class="SustainabilityPage">
    <div class="BaseLayout global-wrapper">
      <BaseHeading
        tag="h1"
        size="h1-lg"
        :class="$b('heading')"
      >
        {{ sustainabilityResponse.title }}
      </BaseHeading>
      <BaseCopy
        tag="p"
        size="h2"
        :class="$b('intro')"
      >
        {{ sustainabilityResponse.intro }}
      </BaseCopy>
      <div
        v-for="row in sustainabilityResponse.rows"
        :key="row.id"
        :class="$b('row')"
      >
        <div
          v-for="column in row.columns"
          :key="column.id"
          :class="[$b(`${row.columns.length}-column`), $b('column')]"
        >
          <SustainabilityBlock
            :block="column"
            :columns="row.columns.length"
          />
        </div>
      </div>
    </div>
    <GradientQuote
      :quote="sustainabilityResponse.quote"
      :quote-attribution="sustainabilityResponse.quoteAttribution"
    />
    <section :class="$b('additional-info')">
      <div class="BaseLayout global-wrapper">
        <h2 :class="[$b('additional-info-heading'), 't-h1-md']">
          {{ sustainabilityResponse.sectionTitle }}
        </h2>
        <!-- eslint-disable vue/no-v-html -->
        <div
          :class="$b('additional-info-text')"
          v-html="preparedHtml"
        />
      </div>
    </section>
  </div>
</template>

<script>
import sustainabilityQuery from '~/gql/sustainabilityBlocks.gql.js'

export default defineNuxtComponent({
  name: 'SustainabilityPage',

  async setup () {
    definePageMeta({
      pageType: 'Mission Page'
    })

    const { $head, $sentry, runWithContext } = useNuxtApp()
    const { data: sustainabilityResponse, error } = await useDatoQuery({
      query: sustainabilityQuery
    })

    if(error.value) {
      $sentry.captureException(error)
      createError({
        statusCode: error.value.statusCode,
        statusMessage: error.value.statusMessage
      })
    }

    runWithContext(
      () => useHead($head(sustainabilityResponse.value.sustainabilityPage.meta))
    )

    return {
      sustainabilityResponse: sustainabilityResponse.value.sustainabilityPage
    }
  },

  computed: {
    // ...mapGetters({
    //   openModalMetaTags: 'modal/openModalMetaTags'
    // }),
    preparedHtml () {
      return this.$md.render(this.sustainabilityResponse.sectionText)
    }
  }
})
</script>

<style lang="postcss">
.SustainabilityPage__heading {
  @apply t-gradient inline-block
    pb-md md:pb-sm pt-md md:pt-xl;
}

.SustainabilityPage__intro {
  @apply pb-md md:pb-lg mdMax:mr-sm
    mdMax:text-base;
}

.SustainabilityPage__row {
  @apply md:mt-xxxs
    flex flex-wrap md:flex-nowrap;
  margin-bottom: calc(theme('spacing.xs') * 2);
}

.SustainabilityPage__column {
  @apply flex-grow flex flex-col;
  min-height: 30rem;
  
  @screen md {
    min-height: 40rem;
  }
}

.SustainabilityPage__2-column {
  flex: 1 1 100%;

  @screen md {
    min-height: 43.3333rem;
    flex-basis: 50%;
  }

  &:first-child {
    @apply md:mr-xs mdMax:mb-sm;
  }

  &:last-child {
    @apply md:ml-xs;
  }
}

.SustainabilityPage__additional-info{
  @apply mb-lg hidden;
}

.SustainabilityPage__additional-info-heading {
  @apply pb-md md:pb-sm;
}

.SustainabilityPage__additional-info-text {
  @apply pb-md md:pb-sm max-w-[780px];

  p {
    @apply text-sm md:text-base;

    + p {
      @apply mt-md mdMax:pt-xxs md:mt-lg
    }

    a {
      @apply mb-sm t-gradient underline
        inline-block relative p-xxxs pb-0;
      
      margin-top: calc(0px - theme('spacing.xxxs'));
      margin-left: calc(0px - theme('spacing.xxxs'));
      margin-right: calc(0px - theme('spacing.xxxs'));

      &::after {
        transition: opacity 0.3s ease-in-out;
        opacity: 0.3;
        background-image: var(--gradient-default);
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        height: 1px;
        width: calc(100% - (theme('spacing.xxxs') * 2));
        display: block;
      }

      &:hover::after {
        opacity: 1;
      }
    }
  }
}
</style>
